import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'react-redux-form';
import { Row, Col } from 'react-bootstrap';
import Translation from '../../../../../../common/translation/translation.component';
import { TRANSLATIONS as translation } from '../../../../../../../utils/constant.utils';
import { validateEmail } from '../../../../../../../utils/validation.utils';
import {
    OR_RRF_TextArea as TextArea
    , ORFButton as Button
    , OR_RRF_InputField as InputField
    , OR_RRF_Select as Select
    , ORFSearchSuggestions as SearchSuggestions
    , ORFDatePicker
} from '../../../../../../common/forms/order-request-form.component';
import { newCircuitSubscriptionActions } from "./../../../../../../../store/external/request-reducer/order-request-reducer/wireline-request/new-circuit/new-circuit-subscription.reducer";
import { createRequestActions } from "./../../../../../../../store/external/request-reducer/create-request.reducer";
import { requestLogActions } from "./../../../../../../../store/external/request-reducer/request-log.reducer";
import { fileAttachmentActions } from "./../../../../../../../store/external/common-reducer/file-attachment.reducer";
import FileAttachment from '../../../../../../common/file-attachment/file-attachment.component';
import Icons from '../../../../../../icon';
import { trueFalseToBoolean } from '../../../../../../../utils/helpers.utils';

class NewCircuitBusinessForm extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    toggleLocalContainer() {
        this.setState({ localToggle: !this.state.localToggle })
    }

    toggleAlterContainer() {
        this.setState({ alterToggle: !this.state.alterToggle })
    }

    setNeedByDate = (v) => {
        this.props.onDateSelect(v);
    }

    submitRequest = async () => {
        /*const { needByDate } = this.state*/
        const { modalMessage, submitRequest, fetchRequestLogItems, uploadFile, saveOrderFile } = this.props;

        var success = await submitRequest(this.props.wirelineBusinessFormA.needByDate);
        if (success.Success) {
            var res = await uploadFile(success.OrderId);
            if (res != null && res.Result) {
                saveOrderFile(success.OrderId, res.FileNames);
            }

            fetchRequestLogItems(0);
        }
        modalMessage(success);
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    render() {
       /* const { needByDate } = this.state*/
        const {
            //component props
            onClickCancel
            , prevAction
            //form
            , wirelineBusinessFormA
            //reducer action
            , onApproverSelect
            , onGLCodeSelect
            , onCostCenterSelect
            , onDateSelect
            , fetchEmployeeByValue
            , fetchGLCodeByValue
            , fetchCostCenterByValue
        } = this.props;
        const { employeeList, glCodeList, costCenterList } = this.props.createRequest;
        const { purposeOfUseOptions, formSubmitted } = this.props.newCircuitRequest;
    
        const today = new Date()

        let tomorrow = new Date()

        tomorrow.setDate(today.getDate() + 1)

        const mindate = tomorrow;

        //mindate.setDate(mindate.getDay + 1)

        let expediteOptions = [
            {
                "Key": true,
                "Value": "Yes"
            },
            {
                "Key": false,
                "Value": "No"
            }
        ];
        return (
            <div>
                <Form method="post" role="form"
                    model="wirelineBusinessFormA"
                    onSubmit={this.submitRequest}
                >
                    <div>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <SearchSuggestions
                                    value={wirelineBusinessFormA.wireLineApprover}
                                    label={`${this.toLocaleLanguage('approver')} *`}
                                    propDisplay={'Name'}
                                    options={employeeList.length > 0 ? employeeList : ''}
                                    onChangeAction={onApproverSelect}
                                    searchAction={fetchEmployeeByValue}
                                />
                            </Col>
                        </Row>
                        <div className="local-contact-container" onClick={this.toggleLocalContainer.bind(this)}>
                            <Icons
                                customClassName="icon-circle-plus"
                                name={this.state.localToggle ? `circle-minus-reg` : `circle-plus-reg`}
                                size="20px"
                                containerClass="icon-circle-plus-container"
                            />
                            <h1 className="local-contact-header"><Translation translationKey="local_contact_title" /></h1>
                        </div>
                        {this.state.localToggle ?
                            <div className="local-list-container">
                                <Row>
                                    <Col xs={12} md={12} lg={12}>
                                        <InputField
                                            className="form-control"
                                            type="text"
                                            label={`${this.toLocaleLanguage('local_contact_email_address')} *`}
                                            value={wirelineBusinessFormA.localContactEmail}
                                            fieldProp='.localContactEmail'
                                            disabled={wirelineBusinessFormA.wireLineApproverId == 0}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={12} lg={12}>
                                        <InputField
                                            className="form-control"
                                            type="text"
                                            label={`${this.toLocaleLanguage('local_contact_fullname')} *`}
                                            value={wirelineBusinessFormA.localContactFullName}
                                            fieldProp='.localContactFullName'
                                            disabled={wirelineBusinessFormA.wireLineApproverId == 0}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={12} lg={12}>
                                        <InputField
                                            className="form-control"
                                            type="text"
                                            label={`${this.toLocaleLanguage('local_contact_phone_number')} *`}
                                            value={wirelineBusinessFormA.localContactPhone}
                                            fieldProp='.localContactPhone'
                                            disabled={wirelineBusinessFormA.wireLineApproverId == 0}
                                        />
                                    </Col>
                                </Row>
                            </div>
                            : ""}
                        <div className="local-contact-container" onClick={this.toggleAlterContainer.bind(this)}>
                            <Icons
                                customClassName="icon-circle-plus"
                                name={this.state.alterToggle ? `circle-minus-reg` : `circle-plus-reg`}
                                size="20px"
                                containerClass="icon-circle-plus-container"
                            />
                            <h1 className="local-contact-header"><Translation translationKey="alt_local_contact_title" /></h1>
                        </div>
                        {this.state.alterToggle ?
                            <div className="alter-list-container">
                                <Row>
                                    <Col xs={12} md={12} lg={12}>
                                        <InputField
                                            className="form-control"
                                            type="text"
                                            label={`${this.toLocaleLanguage('alt_local_contact_email_address')} *`}
                                            value={wirelineBusinessFormA.altLocalContactEmail}
                                            fieldProp='.altLocalContactEmail'
                                            disabled={wirelineBusinessFormA.wireLineApproverId == 0}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={12} lg={12}>
                                        <InputField
                                            className="form-control"
                                            type="text"
                                            label={`${this.toLocaleLanguage('alt_local_contact_full_name')} *`}
                                            value={wirelineBusinessFormA.altLocalContactFullName}
                                            fieldProp='.altLocalContactFullName'
                                            disabled={wirelineBusinessFormA.wireLineApproverId == 0}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={12} lg={12}>
                                        <InputField
                                            className="form-control"
                                            type="text"
                                            label={`${this.toLocaleLanguage('alt_local_contact_phone_number')} *`}
                                            value={wirelineBusinessFormA.altLocalContactPhone}
                                            fieldProp='.altLocalContactPhone'
                                            disabled={wirelineBusinessFormA.wireLineApproverId == 0}
                                        />
                                    </Col>
                                </Row>
                            </div>

                            : ""}
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <SearchSuggestions
                                    value={wirelineBusinessFormA.wireLineGlCode}
                                    label={`${this.toLocaleLanguage('gl_code')} *`}
                                    propDisplay={'Glcode'}
                                    options={glCodeList.length > 0 ? glCodeList : ''}
                                    onChangeAction={onGLCodeSelect}
                                    searchAction={fetchGLCodeByValue}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <SearchSuggestions
                                    value={wirelineBusinessFormA.wireLineCostCenter}
                                    label={`${this.toLocaleLanguage('cost_center')} *`}
                                    propDisplay={'CostCenter'}
                                    options={costCenterList.length > 0 ? costCenterList : ''}
                                    onChangeAction={onCostCenterSelect}
                                    searchAction={fetchCostCenterByValue}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <ORFDatePicker label={`${this.toLocaleLanguage('need_by_date')} *`}
                                    value={wirelineBusinessFormA.needByDate}
                                    action={this.setNeedByDate}
                                    disabled={wirelineBusinessFormA.wireLineApproverId == 0}
                                    minDate={mindate}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <Select
                                    className="form-control"
                                    label={`${this.toLocaleLanguage('purpose_of_use')} *`}
                                    options={purposeOfUseOptions}
                                    placeholder={this.toLocaleLanguage('select_purpose')}
                                    fieldProp='.purposeOfUseId'
                                    value={wirelineBusinessFormA.purposeOfUseId}
                                    disabled={wirelineBusinessFormA.wireLineApproverId == 0}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <Select
                                    className="form-control"
                                    label={`${this.toLocaleLanguage('expedite_request')} *`}
                                    options={expediteOptions}
                                    fieldProp='.expediteRequest'
                                    value={wirelineBusinessFormA.expediteRequest}
                                    disabled={wirelineBusinessFormA.wireLineApproverId == 0}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <TextArea
                                    label={`${this.toLocaleLanguage('business_justification')} ${trueFalseToBoolean(wirelineBusinessFormA.expediteRequest)? "*" : ""}`}
                                    fieldProp='.businessJustification'
                                    value={wirelineBusinessFormA.businessJustification}
                                    disabled={wirelineBusinessFormA.wireLineApproverId == 0
                                        || !trueFalseToBoolean(wirelineBusinessFormA.expediteRequest)
                                    }
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <TextArea
                                    label={this.toLocaleLanguage('additional_information')}
                                    fieldProp='.additionalInformation'
                                    value={wirelineBusinessFormA.additionalInformation}
                                    disabled={wirelineBusinessFormA.wireLineApproverId == 0}
                                />
                            </Col>
                        </Row>
                        <FileAttachment />
                        <div className="request-button-continer">
                            <div className="bottom-left">
                                <Button
                                    label={this.toLocaleLanguage('modal_close_cancel_button')}
                                    variant={"light"}
                                    action={onClickCancel}
                                    type="button"
                                />
                            </div>
                            <div className="bottom-right">
                                <div>
                                    <Button
                                        label={this.toLocaleLanguage('back')}
                                        variant={"outline-secondary"}
                                        action={prevAction}
                                    />
                                </div>
                                <div>
                                    <Button
                                        label={this.toLocaleLanguage('submit_request_button')}
                                        variant={"primary"}
                                        type={"submit"}
                                        disabled={
                                            wirelineBusinessFormA.wireLineApproverId == 0
                                            || wirelineBusinessFormA.wireLineGlCodeId == 0
                                            || wirelineBusinessFormA.wireLineCostCenterId == 0
                                            || wirelineBusinessFormA.purposeOfUseId == 0
                                            || !validateEmail(wirelineBusinessFormA.localContactEmail)
                                            || wirelineBusinessFormA.localContactFullName == ''
                                            || wirelineBusinessFormA.localContactPhone == ''
                                            || !validateEmail(wirelineBusinessFormA.altLocalContactEmail)
                                            || wirelineBusinessFormA.altLocalContactFullName == ''
                                            || wirelineBusinessFormA.altLocalContactPhone == ''
                                            || (trueFalseToBoolean(wirelineBusinessFormA.expediteRequest) && wirelineBusinessFormA.businessJustification == '')
                                            || formSubmitted
                                            || wirelineBusinessFormA.needByDate == ''
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
};

export default connect(
    state => {
        const { newCircuitRequest, createRequest, translation } = state;
        const { wirelineBusinessFormA } = state.form;
        return {
            newCircuitRequest
            , wirelineBusinessFormA
            , createRequest
            , ...translation
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, newCircuitSubscriptionActions
                , createRequestActions
                , requestLogActions
                , fileAttachmentActions
            ),
            dispatch
        )
)(NewCircuitBusinessForm);